import React, { useEffect, useState } from "react";
import { Offcanvas,Card, Modal, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import { nFormat } from "../Vendor/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faComment, faNoteSticky, faPrint, faReceipt, faTimes } from "@fortawesome/free-solid-svg-icons";
const SideBar = (props) => {
    const [useModal,setUseModal] = useState(false)
    const [accountNoteSelected,setAccountNoteSelected] = useState(null)
    const [quoteNote,setQuoteNote] = useState('')
    const [accountLst,setAccountLst] = useState([])
    const [filterInput,setFilterInput] = useState('')
    const [loading,setLoading] = useState(false)

    const openAccount = (input) => {
        input.preventDefault();
        const id = input.currentTarget.getAttribute('id');
        /* eslint-disable-next-line react/prop-types */
        if ( props.setOpenModalAccount !== undefined )
        {
            /* eslint-disable-next-line react/prop-types */
            props.setOpenModalAccount(true)
        }
        openAccountById(id)        
    }
    const removeAccount = (input) => {
        input.preventDefault();
        const id = input.currentTarget.getAttribute('id');
        if(id){
            Swal.fire({
                title: '¿Esta seguro de eliminar esta cuenta?',
                // showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: 'Eliminar',
                // denyButtonText: `Don't save`,
            }).then((result)=>{
                if (result.isConfirmed) {
                    execRemoveAccount(id);
                } /*else if (result.isDenied) {
                    Swal.fire('Changes are not saved', '', 'info')
                }*/
            })
        }
    }
    const getComandas = async(input) => {
        input.preventDefault();
        const id = input.currentTarget.getAttribute('id');
        try {
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'get/comandas',{
                account: id,
                token: localStorage.getItem('OSHEN-LOC-STR-TK')
            }),
            data = resource.data;
            /* eslint-disable-next-line react/prop-types */
            props.setComandas(data);
            /* eslint-disable-next-line react/prop-types */
            props.setShowComanda(true);
            /* eslint-disable-next-line react/prop-types */
            props.setAccountComandaSelected(parseInt(id))
        } catch ( err ) {
            console.log('err->', err)
        }
    }    
    const syncAccounts = (accountList) => {
        const data = JSON.parse(localStorage.getItem('_POS_GEN_DATA_'))
        if ( data ) {
            data.accounts = accountList
            localStorage.setItem('_POS_GEN_DATA_',JSON.stringify(data))
        }        
    }
    const execRemoveAccount = async (id) => {
        try{
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'remove/account',{
                account: id,
                token: localStorage.getItem('OSHEN-LOC-STR-TK')
            }),
            data = resource.data;
            if(data.status){
                // Swal.fire({
                //     icon: 'success',
                //     title: 'Éxito',
                //     text: data.msg
                // }).then(()=>{
                //     location.reload();
                // });
                // eslint-disable-next-line react/prop-types
                props.accountSetter(data.accounts);
                // eslint-disable-next-line react/prop-types
                props.setDisabledCustomerOption(false);
                // eslint-disable-next-line react/prop-types
                props.handleShoppingCart([]);
                // eslint-disable-next-line react/prop-types
                props.handleCusRef({value: 0, label: 'Seleccionar un cliente'});
                // eslint-disable-next-line react/prop-types
                props.handleAccountHeadId(0);
                // eslint-disable-next-line react/prop-types
                props.setTableAccount(0);

                //Sincronizar la data de las cuentas
                syncAccounts(data.accounts);
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'Advertencia',
                    text: data.msg
                });
            }
        } catch(error){
            Swal.fire({
                icon: 'error',
                title: 'Error interno',
                text: 'Algo salio mal, favor intenta nuevamente ó contacte al administrador'
            });
        }
    }
    const addNoteToItem = async () => {
        if ( accountNoteSelected === null ) {
            Swal.fire({
                icon: 'warning',
                title: 'Advertencia',
                text: 'La cuenta no ha sido encontrada, favor actualizar e intentar nuevamente'
            });
            return
        }
        try{
            // eslint-disable-next-line no-undef
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'add/account/note',{
                account: accountNoteSelected,
                note: quoteNote,
                token: localStorage.getItem('OSHEN-LOC-STR-TK')
            }),
            data = resource.data;
            if(data.status)
            {                        
                // eslint-disable-next-line react/prop-types
                props.accountSetter(data.accounts);
                // eslint-disable-next-line react/prop-types
                props.setDisabledCustomerOption(false);
                // eslint-disable-next-line react/prop-types
                props.handleShoppingCart([]);
                // eslint-disable-next-line react/prop-types
                props.handleCusRef({value: 0, label: 'Seleccionar un cliente'});
                // eslint-disable-next-line react/prop-types
                props.handleAccountHeadId(0);
                // eslint-disable-next-line react/prop-types
                props.setTableAccount(0);

                setAccountNoteSelected(null)
                setUseModal(false)
                setQuoteNote("")
            } 
            else 
            {
                Swal.fire({
                    icon: 'warning',
                    title: 'Advertencia',
                    text: data.msg
                });
            }
        } catch(error){
            Swal.fire({
                icon: 'error',
                title: 'Error interno',
                text: 'Algo salio mal, favor intenta nuevamente ó contacte al administrador'
            });
        }
    }
    const openAccountById = async (id, sideBarStatus) => {
        const sbs = sideBarStatus !== undefined ? sideBarStatus : true
        if(id)
        {
            const accounts = await getAccountsList()
            // console.log('<<accounts>>',accounts)
            // console.log('<<id>>',id)
            { /* eslint-disable-next-line react/prop-types */ }
            // const accounts = props.accounts;
            // console.log("Compare with:::...", accounts);
            // eslint-disable-next-line react/prop-types
            for(let i=0;i<accounts.length;i++)
            {
                const obj = accounts[i];
                // eslint-disable-next-line react/prop-types
                // console.log("Compare with:::...", parseInt(obj.id), parseInt(id));                
                // eslint-disable-next-line react/prop-types
                if(parseInt(obj.id)==parseInt(id))
                {  
                    let productHandled = []                  
                    { /* eslint-disable-next-line react/prop-types */ }
                    for ( let counterPosDetail = 0; counterPosDetail < obj.posDetail.length; counterPosDetail++)
                    {
                        let addToList = true;
                        { /* eslint-disable-next-line react/prop-types */ }
                        const posDetailObject = obj.posDetail[counterPosDetail];
                        if ( productHandled )
                            for ( let counterProductCheck = 0; counterProductCheck < productHandled.length; counterProductCheck++)
                            {
                                const obj2 = productHandled[counterProductCheck]
                                { /* eslint-disable-next-line react/prop-types */ }
                                if (Number(posDetailObject.product_id) === obj2.product_id && Number(posDetailObject.unit_id) === obj2.unit_id && Number(posDetailObject.condition_id) === obj2.condition_id)
                                {
                                    addToList = false;
                                    { /* eslint-disable-next-line react/prop-types */ }
                                    obj.posDetail[counterPosDetail].showQty = 0
                                    { /* eslint-disable-next-line react/prop-types */ }
                                    obj.posDetail[counterPosDetail].showingUp = false
                                }
                            }

                        if ( addToList )
                        {
                            { /* eslint-disable-next-line react/prop-types */ }
                            obj.posDetail[counterPosDetail].showQty = 0
                            { /* eslint-disable-next-line react/prop-types */ }
                            obj.posDetail[counterPosDetail].showingUp = true
                            { /* eslint-disable-next-line react/prop-types */ }
                            productHandled.push({product_id: Number(posDetailObject.product_id),unit_id: Number(posDetailObject.unit_id),condition_id: Number(posDetailObject.condition_id)})
                        }
                        
                    }
                    { /* eslint-disable-next-line react/prop-types */ }
                    props.handleShoppingCart(obj.posDetail);                    
                    const inputCustomerOption = {
                        // eslint-disable-next-line react/prop-types
                        value: obj.customer_id, 
                        // eslint-disable-next-line react/prop-types
                        label: obj.customer_label,
                        // eslint-disable-next-line react/prop-types
                        document_type: obj.document_type,
                        // eslint-disable-next-line react/prop-types
                        document_type_id: obj.document_type_id
                    };
                    // eslint-disable-next-line react/prop-types
                    props.handleCusRef(inputCustomerOption);
                    // eslint-disable-next-line react/prop-types
                    props.handleAccountHeadId(obj.id);
                    if ( sbs )
                    {
                        // eslint-disable-next-line react/prop-types
                        props.handleShow();
                    }
                    // eslint-disable-next-line react/prop-types
                    props.setDisabledCustomerOption(true);
                    // eslint-disable-next-line react/prop-types
                    props.setDefaultCurrency(obj.currency_id);

                    // eslint-disable-next-line react/prop-types
                    if(obj.mesa_id!=null){
                        // eslint-disable-next-line react/prop-types
                        props.setTableAccount(obj.mesa_id);
                        let areaText = "";
                        // eslint-disable-next-line react/prop-types
                        for(let i=0;i<props.accountTables.length;i++) {
                            // eslint-disable-next-line react/prop-types
                            if ( parseInt(obj.mesa_id)===parseInt(props.accountTables[i].value) )
                            {
                                // eslint-disable-next-line react/prop-types
                                areaText = props.accountTables[i].description;
                                break;
                            }
                        }
                        // eslint-disable-next-line react/prop-types
                        props.setTableAccountDescription(areaText)
                    } else {
                        // eslint-disable-next-line react/prop-types
                        props.setTableAccount(0);
                        // eslint-disable-next-line react/prop-types
                        props.setTableAccountDescription("")
                    }

                    // eslint-disable-next-line react/prop-types
                    if ( obj.posDetail !== undefined && obj.posDetail !== null && obj.posDetail.length )
                    {
                        let additionalArr = []
                        // eslint-disable-next-line react/prop-types
                        for (let posDCounter = 0; posDCounter < obj.posDetail.length; posDCounter++)
                        {
                            // eslint-disable-next-line react/prop-types
                            const pdObject = obj.posDetail[posDCounter];
                            // eslint-disable-next-line react/prop-types
                            if ( pdObject.additional !== undefined && pdObject.additional !== null && pdObject.additional.length ) 
                            {
                                let additionalObject = {
                                    // eslint-disable-next-line react/prop-types
                                    product_id : Number(pdObject.product_id),
                                    // eslint-disable-next-line react/prop-types
                                    condition_id : Number(pdObject.condition_id),
                                    // eslint-disable-next-line react/prop-types
                                    unit_id : Number(pdObject.unit_id),
                                    // eslint-disable-next-line react/prop-types
                                    extraSelected: [...pdObject.additional]
                                }                                
                                // let additionalArr = [additionalObject]
                                additionalArr.push(additionalObject)
                                // eslint-disable-next-line react/prop-types
                                // props.setCurrentFittingData(additionalObject)
                                // eslint-disable-next-line react/prop-types
                                // props.setSelectFittingData(additionalArr)
                                // eslint-disable-next-line react/prop-types
                                // props.setCurrentProductSelected(additionalObject)
                                // break;
                            }
                        } 
                        // eslint-disable-next-line react/prop-types
                        props.setSelectFittingData(additionalArr)                       
                    }
                }
            }
        }
    }
    const searchFilterInput = (input) => {
        const criteria = input.target.value
        setFilterInput(criteria)
        if ( !criteria )
        {
            /* eslint-disable-next-line react/prop-types */
            setAccountLst(props.accounts)
            return
        }

        /* eslint-disable-next-line react/prop-types */
        const localAccountLst = [...props.accounts]
        let arrFilterBy = []
        arrFilterBy = localAccountLst.filter(({customer_label}) => {
            return customer_label.toLowerCase().includes(criteria.toLowerCase())
        });
        if ( arrFilterBy.length < 1 )
        {
            arrFilterBy = localAccountLst.filter(({mesa_des}) => {
                mesa_des = mesa_des?mesa_des:"";
                return mesa_des.toLowerCase().includes(criteria.toLowerCase())
            });
        }
        if ( arrFilterBy.length < 1 )
        {
            arrFilterBy = localAccountLst.filter(({id}) => {
                return id.toLowerCase().includes(criteria.toLowerCase())
            });
        }
        setAccountLst(arrFilterBy)
    }
    const getAccountsList = async() => {
        setLoading(true)
        try {
            const resource = await axios.post(process.env.REACT_APP_PATH_API + 'get/accounts/list',{
                /* eslint-disable-next-line react/prop-types */
                defineCurrencyId: props.defaultCurrency,
                token: localStorage.getItem('OSHEN-LOC-STR-TK')
            }),
            data = resource.data;
            setAccountLst(data.accounts)
            /* eslint-disable-next-line react/prop-types */
            props.accountSetter(data.accounts)
            setLoading(false)
            return data.accounts
        } catch ( err ) {
            setLoading(false)
            console.log('err->', err)
        }
    }
    useEffect(()=>{
        {/* eslint-disable-next-line react/prop-types*/}
        if ( props.openAccountRegistered !== null )
        {
            {/* eslint-disable-next-line react/prop-types*/}
            openAccountById(props.openAccountRegistered, false)
        }
    {/* eslint-disable-next-line react/prop-types*/}
    },[props.openAccountRegistered])
    useEffect(()=>{
        /* eslint-disable-next-line react/prop-types */
        setAccountLst(props.accounts)
    /* eslint-disable-next-line react/prop-types */
    },[props.accounts])
    useEffect(()=>{
        {/* eslint-disable-next-line react/prop-types*/}
        if ( !props.show )
        {
            setFilterInput('');
            {/* eslint-disable-next-line react/prop-types*/}
            setAccountLst([...props.accounts])            
        }
        else
        {
            //call accounts list
            getAccountsList();
        }
    {/* eslint-disable-next-line react/prop-types*/}
    },[props.show])    
    return (
        <>
            {/* eslint-disable-next-line react/prop-types*/}
            <Offcanvas show={props.show} onHide={props.handleShow}>
                <Offcanvas.Header closeButton>
                <Offcanvas.Title>Listado de cuentas</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body style={{padding: 0}}> 
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <input 
                                    type="text" 
                                    id="filter-input-side" 
                                    placeholder="Buscar cuenta por criterio" 
                                    value={filterInput} 
                                    onChange={searchFilterInput} 
                                    className="form-control"
                                    style={{marginTop: 15}} 
                                />
                            </div>
                        </div>                   
                        {                            
                            loading?
                                <p style={{textAlign: 'center'}}>Cargando cuentas...</p>
                            :
                            /* eslint-disable-next-line react/prop-types */                            
                            accountLst!==undefined&&accountLst!==null&&accountLst.length? accountLst.map((element,idx)=>{
                                return (
                                    <Card 
                                        key={idx} 
                                        style={{ 
                                            width: '100%',
                                            marginTop: '15px', 
                                            borderTop: 'none', 
                                            borderRight: 'none',
                                            borderLeft: 'none',
                                            borderBottom: '1px solid #ababa',
                                            borderRadius: '0'
                                        }}>
                                        <Card.Body>
                                            {
                                                element.mesaCount!==undefined&&element.mesaCount!==null&&parseInt(element.mesaCount)>0?
                                                    <span className="badge text-bg-danger mb-3">
                                                        Cantidad de cuentas en el area: #{element.mesaCount}
                                                    </span>
                                                :null
                                            }                                        
                                            <Card.Title>{element.customer_name}</Card.Title>
                                            <Card.Subtitle className="mb-3">
                                                <strong>Mesero:</strong> {element.user_name}
                                            </Card.Subtitle>
                                            <Card.Subtitle className="mb-3">
                                                <strong>Cuenta:</strong> #{element.quote_no?element.quote_no:element.id}
                                                {
                                                    (element.mesa_id!=null)?
                                                    <>
                                                        <br /> <span className="badge text-bg-primary">{element.mesa_des}</span>
                                                    </>
                                                    :null
                                                }
                                            </Card.Subtitle>
                                            {
                                                element.quote_note!==undefined&&element.quote_note!==null&&element.quote_note.length?
                                                    <Card.Subtitle className="mb-3">                                                    
                                                        <strong>Nota:</strong> {element.quote_note}
                                                    </Card.Subtitle>
                                                :null
                                            }
                                            <Card.Text>
                                                {/* eslint-disable-next-line react/prop-types */}
                                                <strong>Monto.</strong> <span style={{fontWeight: 'bold',fontSize: '18px'}}>{nFormat(props.outDecimals==0?Math.round(parseFloat(element.total_amount)).toFixed(props.outDecimals):parseFloat(element.total_amount).toFixed(props.outDecimals))}</span>
                                            </Card.Text>
                                            <Card.Link style={{marginLeft: '5vh'}}></Card.Link>
                                            {
                                                // eslint-disable-next-line react/prop-types
                                                parseInt(props.accountHeadId)!==parseInt(element.id)?
                                                    <Card.Link id={element.id} cur={element.currency_id} href="#" onClick={openAccount} title="Seleccionar cuenta">
                                                        <FontAwesomeIcon icon={faCheck} style={{fontSize: 30}} />
                                                    </Card.Link>
                                                :null
                                            }                                            
                                            {/* eslint-disable-next-line no-undef */}
                                            <Card.Link href={`${process.env.REACT_APP_PATH_APP}print/pos/account/ticket/${element.id_md5}`} target="_blank" style={{marginLeft: 32}} title="Imprimir cuenta">
                                                <FontAwesomeIcon icon={faPrint} style={{fontSize: 30}} />
                                            </Card.Link>
                                            <Card.Link id={element.id} target="_blank" style={{marginLeft: 32}} title="Imprimir comandas" onClick={getComandas}>
                                                <FontAwesomeIcon icon={faReceipt} style={{fontSize: 30}} />
                                            </Card.Link>
                                            <Card.Link onClick={()=>{
                                                setAccountNoteSelected(element.id)
                                                setUseModal(true)
                                            }} style={{marginLeft: 32}} title="Agregar nota">
                                                <FontAwesomeIcon icon={element.quote_note!==undefined&&element.quote_note!==null&&element.quote_note.length?faComment:faNoteSticky} style={{fontSize: 30}} />
                                            </Card.Link>
                                            {
                                                // eslint-disable-next-line react/prop-types
                                                props.removePermission?
                                                    <Card.Link id={element.id} href="#" onClick={removeAccount} style={{color: '#f00', marginLeft: 32}} title="Remover cuenta">
                                                        <FontAwesomeIcon icon={faTimes} style={{fontSize: 30}} />
                                                    </Card.Link>
                                                :null
                                            }                                        
                                        </Card.Body>
                                    </Card>
                                )
                            }) : null
                        }   
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            <Modal fullscreen={false} show={useModal} onHide={()=>setUseModal(false)}>
                <Modal.Header className="custom-modal-header" closeButton>
                    <Modal.Title>¿Nota para cuenta #{accountNoteSelected} que te gustaría agregar?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col">
                        <input 
                            type="text" 
                            className="form-control" 
                            placeholder="Modificar la nota"
                            onKeyDown={(e)=>{
                                if(e.key==='Enter'){
                                    addNoteToItem()
                                }
                            }}
                            onChange={(input)=>{                                        
                                setQuoteNote(input.target.value)
                            }} 
                        />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={addNoteToItem}>
                        Agregar Nota
                    </Button>                              
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default SideBar;